export const createElementKey = (blockName: string, index: number): string => `${blockName}-${index}`;
